import React, { useMemo } from 'react';
import Dashboard from './Dashboard';

const SchoolDashboard = () => {
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;

  const normalizeClassName = (cls) => {
    if (!cls) return null;
    const mapping = {
      'I': 'I', 'Class I': 'I', 'ClassI': 'I',
      'II': 'II', 'Class II': 'II', 'ClassII': 'II',
      'III': 'III', 'Class III': 'III', 'ClassIII': 'III',
      'IV': 'IV', 'Class IV': 'IV', 'ClassIV': 'IV',
      'V': 'V', 'Class V': 'V', 'ClassV': 'V',
      'VI': 'VI', 'Class VI': 'VI', 'ClassVI': 'VI',
      'VII': 'VII', 'Class VII': 'VII', 'ClassVII': 'VII',
      'VIII': 'VIII', 'Class VIII': 'VIII', 'ClassVIII': 'VIII',
      'IX': 'IX', 'Class IX': 'IX', 'ClassIX': 'IX',
      'X': 'X', 'Class X': 'X', 'ClassX': 'X'
    };
    return mapping[cls.trim()] || cls.trim();
  };

  const enabledClasses = useMemo(() => {
    if (!user || !user.classes) return [];
    if (typeof user.classes === 'string') {
      return user.classes
        .split(',')
        .map(normalizeClassName)
        .filter(Boolean);
    }
    if (typeof user.classes === 'object') {
      return Object.entries(user.classes)
        .filter(([, value]) => value)
        .map(([cls]) => normalizeClassName(cls));
    }
    return [];
  }, [user]);

  const isAdmin = user?.role === 'Admin';
  const schoolName = user?.schoolName || user?.name || 'default';

  return (
    <Dashboard
      hideManageUsers={!isAdmin}
      viewerOnly={!isAdmin}
      allowedClasses={isAdmin ? [] : enabledClasses}
      schoolName={schoolName}
      title="School Dashboard"
    />
  );
};

export default SchoolDashboard;
